// extracted by mini-css-extract-plugin
export default {"ButtonToInternalLink":"sharedStyles_ButtonToInternalLink__8CL26"};